import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import FormatTooling from '../../../tooling/formatTooling';
import Constants from '../../../definitions/constants';

import GlassPopup from '../common/interface/glassPopup';
import ToggleSection from '../common/interface/toggleSection';
import TextBox from '../common/inputs/textBox';
import CheckBox from '../common/inputs/checkBox';
import Select from '../common/inputs/select';
import SelectList from '../common/inputs/selectList';
import MetricJoinSelector from './metricJoinSelector';
import ObjectDefinitionEditor from '../common/inputs/objectDefinitionEditor';
import ObjectMetricVirtualMarksLabelEditor from '../common/inputs/objectMetricVirtualMarksLabelEditor';
import Label from '../common/inputs/label';
import ErrorFeedback from '../common/feedback/errorFeedback';
import VersionsTable from '../common/versions/versionsTable';
import ColumnsSelectList from './columnsSelecList';
import TagsSelector from '../common/inputs/tagsSelector';

const FormPopup = props => {
  const {
    handleShowPopup,
    handleOnChangeForm,
    handleButton,
    loadingButton,
    fullLoading,
    statusButton,
    formData,
    dimensionsList,
    metricsList,
    errors,
    entityNameSingular,
    popupState,
    handleShowMetricVersionPopup,
    getSelectKeysFromArrayWithMetricHandler,
    handleAutoGenerateDimensions,
    handleAutoGenerateValues,
    handleShowAllTextInJoinsClick,
    showAllTextInJoins,
    handleEntityQueryDataPopup,
    tagsOptions,
  } = props;

  let joinDimensions = JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"metric.virtual_metric_definition.joins") ? JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"metric.virtual_metric_definition.joins") : []
  let selectedDimensions = JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"metric.virtual_metric_definition.dimensions") ? JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"metric.virtual_metric_definition.dimensions") : []
  let selectedMetrics = joinDimensions.map(metric=>+metric.metric_id)

  //Generate the available dimensions dictionary, which contains the data of the dimension and the metric it belongs to
  let availableDimensions = []
  metricsList.forEach(metric => {
    if(selectedMetrics.includes(metric.id)) {
      metric.dimensions.map(dimension => {
        availableDimensions = availableDimensions.concat([{...dimension, metric_id: metric.id}])
      })
    }
  })
  
  //Generate the available values array, which its the already selected metrics. If a metric is an object, instead, its properties are added one by one to the array
  let valuesOptions = []
  metricsList.forEach(metric => {
    if(selectedMetrics.includes(metric.id)) {
      if(metric.data_type == 'object'){
        metric.object_definition.map(prop => {
          valuesOptions = valuesOptions.concat([{...prop, metric_id: metric.id}])
        })
      }
      else {
        valuesOptions = valuesOptions.concat([metric])
      }
    }
  })

  return (
    <GlassPopup
      className="form_popup virtual_metric_form_popup"
      title={(<FormattedMessage 
         id={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"metric.id") ? "common.entity.editEntity" : "common.entity.createEntity"}
         values={{entityNameSingular: entityNameSingular}}
       />)}
      buttonText={(<FormattedMessage 
         id={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"metric.id") ? "common.entity.editEntity" : "common.entity.createEntity"}
         values={{entityNameSingular: entityNameSingular}}
       />)}
      type={Constants.interface.popup.types.LATERAL}
      {...props}
    >
      <ErrorFeedback
        status={statusButton}
        fieldErrors={errors}
        localesFieldsPath="virtualMetricAdmin.fields"
        optionalStatusErrors={{
          "406": intl.formatMessage({id: "common.entity.saveEntityCantDeactivateError"},
             {entityNameSingular: FormatTooling.toUpperCaseFirst(intl.formatMessage({id: "virtualMetricAdmin.entityNameSingularWithArticle"})), 
              detail: (errors.message ? intl.formatMessage({id: "common.errors.detailLabel"}) + errors.message : "")
             })
        }}
      />
      {JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"metric.id") && (
        <i 
          className="fas fa-search entity_use_query_icon" 
          data-entityid={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"metric.id")} 
          onClick={handleEntityQueryDataPopup}
        />
      )}
      <TextBox 
        styleType={Constants.interface.inputs.styleType.OUTLINED}
        type={Constants.interface.inputs.type.TEXT}
        id="name"
        data-path="metric.name"
        value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"metric.name")}
        onChange={handleOnChangeForm}
        labelLocale={<FormattedMessage id="virtualMetricAdmin.fields.name"/>}
        className={("name" in errors) ? "has_error" : null}
      />
      <MetricJoinSelector
        id="joins"
        data-path="metric.virtual_metric_definition.joins"
        onChange={handleOnChangeForm}
        values={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"metric.virtual_metric_definition.joins") ? JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"metric.virtual_metric_definition.joins") : []}
        metricsList={metricsList}
        dimensionsList={dimensionsList}
        getSelectKeysFromArrayWithMetricHandler={getSelectKeysFromArrayWithMetricHandler}
        handleShowAllTextClick={handleShowAllTextInJoinsClick}
        showAllTextInJoins={showAllTextInJoins}
        className={("virtual_metric_definition_joins" in errors) ? "has_error" : null}
        disabled={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"metric.id") ? true : false}
      />
      <ColumnsSelectList
        id="dimensions"
        data-path="metric.virtual_metric_definition.dimensions"
        onChange={handleOnChangeForm}
        values={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"metric.virtual_metric_definition.dimensions") ? JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"metric.virtual_metric_definition.dimensions") : []}
        dimensionsList={dimensionsList}
        metricsList={metricsList}
        columnOptions={availableDimensions}
        columnSelector={true}
        getSelectKeysFromArrayWithMetricHandler={getSelectKeysFromArrayWithMetricHandler}
        handleAutoGenerate={handleAutoGenerateDimensions}
        disabled={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"metric.id") ? true : false}
        className={"column_selector" + ("virtual_metric_definition_dimensions " in errors ? " has_error" : "")}
      />
      <ColumnsSelectList
        id="values"
        data-path="metric.virtual_metric_definition.values"
        onChange={handleOnChangeForm}
        values={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"metric.virtual_metric_definition.values") ? JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"metric.virtual_metric_definition.values") : []}
        dimensionsList={dimensionsList}
        metricsList={metricsList}
        columnOptions={valuesOptions}
        getSelectKeysFromArrayWithMetricHandler={getSelectKeysFromArrayWithMetricHandler}
        handleAutoGenerate={handleAutoGenerateValues}
        disabled={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"metric.id") ? true : false}
        className={"column_selector" + ("virtual_metric_definition_values " in errors ? " has_error" : "")}
      />
      <ToggleSection title={<FormattedMessage id="metricAdmin.fields.reportsConfigTitle"/>}>
        <div>
          <TextBox 
            styleType={Constants.interface.inputs.styleType.OUTLINED}
            type={Constants.interface.inputs.type.TEXT}
            id="report_value_label"
            data-path="metric.report_value_label"
            value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"metric.report_value_label")}
            onChange={handleOnChangeForm}
            labelLocale={<FormattedMessage id="metricAdmin.fields.report_value_label"/>}
            className={("report_value_label" in errors) ? "has_error" : null}
          />
          <TextBox 
            styleType={Constants.interface.inputs.styleType.OUTLINED}
            type={Constants.interface.inputs.type.TEXT}
            id="format"
            data-path="metric.format"
            value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"metric.format")}
            onChange={handleOnChangeForm}
            labelLocale={<FormattedMessage id="metricAdmin.fields.format"/>}
            className={("format" in errors) ? "has_error" : null}
          />
          <ObjectMetricVirtualMarksLabelEditor 
            id="virtual_marks_labels"
            data-path="metric.virtual_marks_labels"
            values={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"metric.virtual_marks_labels")}
            onChange={handleOnChangeForm}
            className={("virtual_marks_labels" in errors) ? "has_error" : null}
          />
        </div>
      </ToggleSection>
      <CheckBox 
        id="distinct"
        data-path="metric.virtual_metric_definition.distinct"
        value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"metric.virtual_metric_definition.distinct")}
        onChange={handleOnChangeForm}
        disabled={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"metric.id") ? true : false}
        labelLocale={<FormattedMessage id="virtualMetricAdmin.fields.distinct"/>}
        className={"virtual_metric_definition_distinc_checkbox"}
      />
      {JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"metric.id") && (
        <CheckBox 
          id="active"
          data-path="metric.active"
          value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"metric.active")}
          onChange={handleOnChangeForm}
          labelLocale={<FormattedMessage id="common.entity.fields.active"/>}
        />
      )}
      <TagsSelector
        id="tags"
        values={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"metric.tags")}
        onClickOption={handleOnChangeForm}
        options={tagsOptions}
        data-path="metric.tags"
      />
    </GlassPopup>
  );
};

export default FormPopup;



// WEBPACK FOOTER //
// ./source/client/components/virtualMetricAdmin/formPopup.jsx